import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_030.jpg';
page.paint = [
  {
    id: 'page015_game4',
    icon: 'ikona_cw5',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Zbuduj wieżę z figur.  ',
      audio: 'files/page015/z15c4.mp3',
      item: {
        path: 'informatyka/files/page015/z.15cw.4.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 800,
    },
  },
  {
    id: 'page015_game3',
    icon: 'ikona_cw4',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Dokończ rysować mur za pomocą narzędzia <i>Prostokąt</i>.  ',
      audio: 'files/page015/z15c3.mp3',
      item: {
        path: 'informatyka/files/page015/z.15cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 600,
    },
  },
  {
    id: 'page015_game3b',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Dokończ rysunki za pomocą narzędzia <i>Owal</i>. Kliknij <br/>w ikonę programu Paint.',
      audio: 'files/page015/z15c3b.mp3',
      item: {
        path: 'informatyka/files/page015/z.15cw.3b.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
  {
    id: 'page015_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Dokończ rysować zegar za pomocą narzędzi <i>Owal</i> oraz <i>Linia</i>.  ',
      audio: 'files/page015/z15c2.mp3',
      item: {
        path: 'informatyka/files/page015/z.15cw.2.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page015_game1',
    icon: 'ikona_cw1',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Zaprojektuj wzór dywanu.  ',
      audio: 'files/page015/z15c1.mp3',
      item: {
        path: 'informatyka/files/page015/z.15cw.1.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 0,
    },
  },
];
page.images = [
  {
    imageId: 'page030_zoom0',
    rectangle: {
      x: 239,
      y: 1190,
      width: 1536,
      height: 338,
    },
    imageSrc: 'images/page030/030 3.jpg',
  },
  {
    imageId: 'page030_zoom1',
    rectangle: {
      x: 143,
      y: 412,
      width: 1228,
      height: 620,
    },
    imageSrc: 'images/page030/030 2.jpg',
  },
  {
    imageId: 'page030_zoom2',
    rectangle: {
      x: 857,
      y: 1934,
      width: 924,
      height: 530,
    },
    imageSrc: 'images/page030/030 1.jpg',
  },
];
page.games = [
  {
    id: 'page030_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: LEFT,
      y: 1929,
    },
    item: {
      id: 'page030_game10',
    },
    rectangle: {
      id: 'page030_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page030_rect0',

    tooltip: '',

    linked: ['page030_game10'],
    x: 120,
    y: 1929,
    width: 585,
    height: 465,
  },
];
export default page;
